/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Type } from '@app/settings/types/types.model';
import { User } from '@app/settings/users/user.model';
import * as moment from 'moment';
import { Events } from '@app/events/events/events.model';
import { Logger } from '@app/core';

const log = new Logger('Comment model');

export class CommentModel extends Model {
  id: number;
  type_id: number;
  type?: Type;
  user?: User;
  commentable_id: number;
  commentable: any;
  commentable_type: string;
  comment: string;
  color: string;

  meta_front?: any; // Използва се за едит и подобни неща, които не са нужни на API-то

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.user) {
      this.user = new User().deserialize(this.user);
    }
    return this;
  }

  get colorHex(): string {
    return '#' + this.color;
  }

  get commentHTML(): String {
    let commentHTML = this.comment;
    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;

    commentHTML = commentHTML.replace(urlRegex, (url) => {
      if (!(url.indexOf('https://') === 0) && !(url.indexOf('http://') === 0)) {
        return `<a href="https://${url}" target="_blank">${url}</a>`;
      }
      return `<a href="${url}" target="_blank">${url}</a>`;
    });
    commentHTML = commentHTML.replace(emailRegex, (email) => `<a href="mailto:${email}" target="_blank">${email}</a>`);
    commentHTML = commentHTML.replace(/\n/g, '<br/>');

    return commentHTML;
  }

  get cleanCommentableType() {
    const type = this.commentable_type.split('\\');
    return type[type.length - 1];
  }

  get about() {
    let about: any = null;
    if (!this.commentable) {
      return about;
    }
    switch (this.cleanCommentableType) {
      case 'Sale': {
        if (this.commentable.client) {
          about = this.commentable.client.name;
        }

        if (this.commentable.event) {
          about += ' / ' + this.commentable.event.name + ' ' + moment(this.commentable.event.date_from).format('YYYY');
        }
        break;
      }
      case 'User': {
        about = this.commentable.fake_first_name + ' ' + this.commentable.fake_last_name;
        break;
      }
      case 'Client': {
        about = this.commentable.name;
        break;
      }
      case 'Hotel': {
        about = this.commentable.name;
        break;
      }

      case 'EVENT': {
        about = this.commentable.name;
        break;
      }
      case 'HotelBooking': {
        if (this.commentable.hotel) {
          about = this.commentable.hotel.name;
        }
        if (this.commentable && this.commentable.events) {
          about += ' / ';
          this.commentable.events.forEach((event: Events, index: Number) => {
            about += event.name + ' ' + moment(event.date_from).format('YYYY');

            if (index !== this.commentable.events.length - 1) {
              about += ', ';
            }
          });
        }
        break;
      }
      case 'HotelBookingCancellation': {
        if (this.commentable.booking && this.commentable.booking.hotel) {
          about = this.commentable.booking.hotel.name;
        }

        if (this.commentable.booking && this.commentable.booking.events) {
          about += ' / ';
          this.commentable.booking.events.forEach((event: Events, index: Number) => {
            about += event.name + ' ' + moment(event.date_from).format('YYYY');

            if (index !== this.commentable.booking.events.length - 1) {
              about += ', ';
            }
          });
        }
        break;
      }

      default: {
        log.error('Unknown commentable type!!! ' + this.cleanCommentableType);
      }
    }
    return about;
  }
}
